<template lang="pug">
div.detail-component
  .tw-flex.tw-flex-row.tw-justify-between.detail-header
    div.detail-title
      h5.h5.tw-text-gray-500 {{$I18n.t('vue.maintenance_detail.title')}}
  hr
  Detailgrid(:data-grid="grid", :data-editing="false")
</template>

<script>
import CoreComponents from "../core";
const { ActiveValue } = require("../../core/active_support");

export default {
  props: { dataRecord: String },
  components: { ...CoreComponents },
  data(){
    this.record = JSON.parse(this.dataRecord);
    const self = this;
    return {
      values: {
        id: ActiveValue().setup(i => {
          i.setLabel(self.$I18n.t('vue.maintenance_detail.id'));
          i.setValue(self.record.id);
          i.setKind('string');
          i.notEditable();
        }),
        vendor: ActiveValue().setup(i => {
          if(!self.record.vendor) return;
          i.setLabel(self.$I18n.t('vue.maintenance_detail.vendor'));
          i.setValue(self.record.vendor.name);
            i.setKind('link');
          i.setLinkOptions({ href: self.record.vendor.paths.show });
          const real = self.record.vendor.tooltip_data || {};
          const fallback = {
            id: self.record.vendor.id || 'N/A',
            name: self.record.vendor.name || 'N/A',
            aka: self.record.vendor.aka || 'N/A',
            phone: self.record.vendor.phone || 'N/A',
            state: self.record.vendor.state || 'N/A'
          };
          i.setTooltipData({ ...fallback, ...real });
          i.notEditable();
        }),
        customer: ActiveValue().setup(i => {
          if(!self.record.customer) return;
          i.setLabel(self.$I18n.t('vue.maintenance_detail.customer'));
          i.setValue(self.record.customer.name);
          i.setKind('link');
          i.setLinkOptions({ href: self.record.customer.paths.show });
          const real = self.record.customer.tooltip_data || {};
          const fallback = {
            id: self.record.customer.id || 'N/A',
            name: self.record.customer.name || 'N/A',
            aka: self.record.customer.aka || 'N/A',
            phone: self.record.customer.phone || 'N/A',
            state: self.record.customer.state || 'N/A'
          };
          i.setTooltipData({ ...fallback, ...real });
          i.notEditable();
        }),
        subsidary: ActiveValue().setup(i => {
          if(!self.record.subsidary) return;
          i.setLabel(self.$I18n.t('vue.maintenance_detail.subsidary'));
          i.setValue(self.record.subsidary.name);
          i.setKind('link');
          i.setLinkOptions({ href: self.record.subsidary.paths.show });
          const real = self.record.subsidary.tooltip_data || {};
          const fallback = {
            id: self.record.subsidary.id || 'N/A',
            name: self.record.subsidary.name || 'N/A',
            phone: (self.record.subsidary.phone && self.record.subsidary.phone.number) || self.record.subsidary.phone || 'N/A',
            keys: self.record.subsidary.keys || 'N/A',
            turn_around_time: self.record.subsidary.turn_around_time || 'N/A',
            fax_number: self.record.subsidary.fax_number || 'N/A',
            alarm: self.record.subsidary.alarm || 'N/A',
            invoice_target: self.record.subsidary.invoice_target || 'N/A',
            address: (self.record.subsidary.address && self.record.subsidary.address.full) || 'N/A'
          };
          i.setTooltipData({ ...fallback, ...real });
          i.notEditable();
        }),
        kind: ActiveValue().setup(i => {
          if(!self.record.kind) return;
          i.setLabel(self.$I18n.t('vue.maintenance_detail.kind'));
          i.setValue(self.record.kind.name);
          i.setKind('link');
          i.setLinkOptions({ href: self.record.kind.paths.show });
          const real = self.record.kind.tooltip_data || {};
          const fallback = {
            id: self.record.kind.id || 'N/A',
            name: self.record.kind.name || 'N/A',
            abbreviation: self.record.kind.abbreviation || 'N/A'
          };
          i.setTooltipData({ ...fallback, ...real });
          i.notEditable();
        }),
        hood: ActiveValue().setup(i => {
          if(!self.record.hood) return;
          i.setLabel(self.$I18n.t('vue.maintenance_detail.hood'));
          i.setValue(self.record.hood.equipment_under);
          i.setKind('link');
          i.setLinkOptions({ href: self.record.hood.paths.show });
          const real = self.record.hood.tooltip_data || {};
          const fallback = {
            id: self.record.hood.id || 'N/A',
            equipment_under: self.record.hood.equipment_under || 'N/A',
            fan_type: self.record.hood.fan_type || 'N/A'
          };
          i.setTooltipData({ ...fallback, ...real });
          i.notEditable();
        }),
        order: ActiveValue().setup(i => {
          if(!self.record.order) return;
          i.setLabel(self.$I18n.t('vue.maintenance_detail.order'));
          i.setValue(self.record.order.id);
          i.setKind('link');
          i.setLinkOptions({ href: self.record.order.paths.show });
          const real = self.record.order.tooltip_data || {};
          const fallback = {
            id: self.record.order.id || 'N/A',
            due_at: self.record.order.locale_due_at || 'N/A',
            schedule_for: self.record.order.locale_schedule_for || 'N/A',
            state: (self.record.order.state && self.record.order.state.name) || 'N/A'
          };
          i.setTooltipData({ ...fallback, ...real });
          i.notEditable();
        }),
      }
    }
  },
  computed:{
    grid(){
      return [
        [this.values.id, this.values.kind],
        [this.values.vendor, this.values.customer],
        [this.values.subsidary, this.values.hood],
        [this.values.order, '']
      ];
    }
  }
}
</script>
